import useBriefContext from '../../../../Hooks/Brief/useBriefContext/useBriefContext'
import { getCurrencySymbol } from '../../../../Utilities/Location/Currency/getCurrencySymbol'
import BudgetCaption from '../BudgetCaption'

interface BizBudgetOptionsInput {
  budget: number | ''
}

const BizBudgetOptions = ({ budget }: BizBudgetOptionsInput): JSX.Element => {
  const { brief } = useBriefContext()
  const currencySymbol = getCurrencySymbol(brief.currency)
  return (
    <BudgetCaption
      budget={budget || undefined}
      currencySymbol={currencySymbol}
      numGuests={brief.capacities ?? 1}
    />
  )
}

export default BizBudgetOptions
